export default {"src":"/_next/static/media/solar_buildings-linear1.754f21b1.svg","height":58,"width":58,"blurWidth":0,"blurHeight":0};